import axios, { API } from "../../api";

/**
 * Soft one-time prompt shown to new premium users encouraging them to connect
 * a social media account so Aura can learn from them. Gentle, not aggressive.
 * Dismissed forever once user picks either action.
 */
export function SocialConnectPrompt({ onConnect, onDismiss }) {
  const handleConnect = async () => {
    try { await axios.post(`${API}/me/dismiss-social-prompt`); } catch (e) { /* noop */ }
    onConnect?.();
  };

  const handleLater = async () => {
    try { await axios.post(`${API}/me/dismiss-social-prompt`); } catch (e) { /* noop */ }
    onDismiss?.();
  };

  return (
    <div className="modal-overlay" onClick={handleLater}>
      <div
        className="social-prompt-modal"
        onClick={(e) => e.stopPropagation()}
        data-testid="social-prompt-modal"
      >
        <div className="social-prompt-emoji">💜</div>
        <h2 className="social-prompt-title">Want Aura to really know you?</h2>
        <p className="social-prompt-body">
          Connect a music account or two and I'll learn what moves you —
          the songs that bring you home, the artists you can't stop playing.
          It's how I get to know you faster.
        </p>
        <p className="social-prompt-reassure">
          <em>Private. You can disconnect anytime.</em>
        </p>

        <button
          className="init-btn"
          onClick={handleConnect}
          data-testid="social-prompt-connect"
        >
          Connect now
        </button>

        <button
          className="ghost-btn small"
          onClick={handleLater}
          data-testid="social-prompt-later"
          style={{ marginTop: "0.5rem" }}
        >
          Maybe later
        </button>
      </div>
    </div>
  );
}
